import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';

@Component({
    selector: 'app-time-overview',
    templateUrl: './time-overview.component.html',
    styleUrls: ['./time-overview.component.scss'],
    standalone: false
})
export class TimeOverviewComponent implements OnInit {
    timeEntries: any;
    workOrderList: any[];
    showAllOrders = false;
    filter: any;
    showAll= false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private router: Router,
        public auth: AuthenticationService,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        const employees = await this.uow.getEmployees();
        await this.getData(500);
    }

    async getData(take?: number) {
        this.timeEntries = await this.uow.getTimeEntries(take);
    }

    async toggleShowAll() {
        this.appInfo.pleaseWaitShow();
        this.showAll = !this.showAll;
        await this.getData(this.showAll ? null : 500);
        this.appInfo.pleaseWaitHide()
    }

    print() {
        const selectedInvoices = this.dataGrid.instance.getSelectedRowsData();
        if (selectedInvoices.length === 0) return;
        const invoiceIds = selectedInvoices.map(x => {
            return x.id;
        });
    }

    search() {}
    clear() {}

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        const filter = e.component.getCombinedFilter();
        if (e.component.__searchChanged || !!filter) {
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                },
                location: 'after'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    async open(id?: number) {
        this.router.navigate(['/jobs/' + (!!id ? id : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data) return;
        await this.open(e.data.jobId);
    }
}
